import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyImage',
  props: {
    src: null,
    parentContainer: { default: null }
  },
  emits: ["viewportIntersect"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'viewportIntersect'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { src: string, parentContainer: HTMLElement | null };





const img = ref<HTMLImageElement | null>(null)
const isLoaded = ref(false)
let loadImageTimeout: ReturnType<typeof setTimeout> |  null

onMounted(() => {
  if (img.value) {
    new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        if (entries.length === 1 && entries[0].isIntersecting) {
          loadImageTimeout = setTimeout(() => {
            if (img.value && img.value.src === '') { 
              img.value.src = props.src
              loadImageTimeout = null
            }
          }, 400)
          emits('viewportIntersect')
        } else if (loadImageTimeout) {
          clearTimeout(loadImageTimeout)
          loadImageTimeout = null
        }   
        if ( isLoaded.value && img.value) {
          img.value.removeAttribute('src')
          isLoaded.value = false
        }
      },
      {
        // Observe intersection with the viewport
        root: props.parentContainer,
        // We may want to adjust this to allow images to start loading slightly earlier than being in the viewport
        rootMargin: '300px 0px 300px 0px'
      }
    ).observe(img.value)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: _normalizeClass(['lazy-image', {'lazy-image--loaded' : isLoaded.value}]),
    ref_key: "img",
    ref: img,
    onLoad: _cache[0] || (_cache[0] = ($event: any) => (isLoaded.value = true))
  }, null, 34))
}
}

})